import update from 'immutability-helper';
import initialState from './shared';
import { yesOrNo } from '../../../../../shared/constants';

export default update(initialState, {
  $merge: {
    exporting: {
      excel: false,
      pdf: []
    },
    queryParams: {
      bookingNo: undefined,
      chassisNo: undefined,
      chassisTypeId: undefined,
      classificationTypeId: undefined,
      containerNo: undefined,
      containerSizeId: undefined,
      containerTypeId: undefined,
      countryId: undefined,
      dateEnd: undefined,
      dateStart: undefined,
      emptyFull: undefined,
      estimationNumber: undefined,
      estimationStateId: undefined,
      etir: undefined,
      field: 'etir',
      gateType: undefined,
      init: 0,
      inventory: yesOrNo(true).yes.value,
      order: 'asc',
      ptcNumber: undefined,
      result: 10
    },
    table: {
      filtered: [],
      sorted: [{
        desc: false,
        id: 'etir'
      }]
    }
  }
});



// WEBPACK FOOTER //
// ./src/containers/Root/reducer/tables/initialState/dashboardAdvancedSearch.js